import $ from 'wee-dom';
import $events from 'wee-events';
import $screen from 'wee-screen';
import { RouteHandler } from 'wee-routes';

const $tabItem = $('.js-tabItem');
const $nestedTabItem = $('.js-nestedTabItem');
const $sublist = $('.footer-navigation__sublist');

function toggleFooterAria() {
	$('.footer-navigation__item').toggleAria(['aria-haspopup','aria-expanded']);
}

export default new RouteHandler({
	init() {
		$events.on({
			'.footer-navigation__item': {
				click(e, el) {
					let $target = $(e.target);

					if ($target.hasClass('-has-menu')) {
						$target.toggleClass('-expanded')
							.toggleAria('aria-expanded')
							.children($sublist)
							.toggleAria('aria-hidden');
					} else {
						$(el).toggleClass('-expanded')
							.toggleAria('aria-expanded')
							.children($sublist)
							.toggleAria('aria-hidden');
					}
				},
				keydown(e, el) {
					let $target = $(e.target),
						$el = $(el),
						sublist = '.footer-navigation__sublist',
						subitem = '.footer-navigation__subitem',
						hasMenu = '.footer-navigation__subitem.-has-menu',
						sublink = '.footer-navigation__sublink';

					if (e.keyCode === 39 || e.keyCode === 40) {
						if ($target.hasClass('-has-menu')) {
							$target.addClass('-expanded')
								.attr('aria-expanded', 'true')
								.children(sublist)
								.attr('aria-hidden', 'false')
								.children(subitem)
								.children(sublink)
								.attr('tabindex', '0');
						} else {
							$el.addClass('-expanded')
								.attr('aria-expanded', 'true')
								.children(sublist)
								.attr('aria-hidden', 'false')
								.children(subitem)
								.children(sublink)
								.attr('tabindex', '0');

							$el.children(sublist)
								.children(hasMenu)
								.attr('tabindex', '0')
								.children(sublink)
								.attr('tabindex', '0');
						}
					} else if(e.keyCode === 37 || e.keyCode === 38) {
						if ($target.hasClass('-has-menu')) {
							$target.removeClass('-expanded')
								.toggleAria('aria-expanded')
								.children(sublist)
								.toggleAria('aria-hidden')
								.children(subitem)
								.children(sublink)
								.attr('tabindex', '-1');
						} else {
							$el.removeClass('-expanded')
								.toggleAria('aria-expanded')
								.children(sublist)
								.toggleAria('aria-hidden')
								.children(subitem)
								.children(sublink)
								.attr('tabindex', '-1');

							$el.children(sublist)
								.children(hasMenu)
								.attr('tabindex', '-1')
								.children(sublink)
								.attr('tabindex', '-1');
						}
					}
				}
			}
		});

		$screen.map([
			{
				max: 3,
				callback() {
					toggleFooterAria();

				}
			},
			{
				min: 4,
				callback() {
					toggleFooterAria();
				}
			}
		]);
	}
});